module.exports = __webpack_public_path__ + "static/img/umbrella.e77d103d.png";